export const accountQueryKey = 'account-query'
